const sshpk = require('sshpk');

module.exports = sshpk;
